import { fetchApiKeys } from '../../../../api/apiKey';

const createValidateKeyName = (intl: any) => {
  return async (_rule?: any, keyName?: string): Promise<void> => {
    if (!keyName || keyName.trim() === '') {
      return Promise.resolve();
    }

    // Check for restricted special characters: # % ? / " \
    const restrictedChars = /[#%?/"\\]/;
    if (restrictedChars.test(keyName)) {
      return Promise.reject(
        new Error(
          intl.formatMessage({
            id: 'ApiKeys.modal.input.validation.keyName',
          }),
        ),
      );
    }
  };
};

const checkDuplicateKeyName = (intl: any) => {
  return async (_rule?: any, keyName?: string): Promise<void> => {
    try {
      if (!keyName?.trim()) {
        return Promise.resolve();
      }
      const { data } = await fetchApiKeys('&status=active');

      if (!data?.result?.length) {
        return Promise.resolve();
      }

      const isKeyNameExist = data.result.some(
        apiKey => apiKey.name?.toLowerCase() === keyName.trim().toLowerCase(),
      );

      if (isKeyNameExist) {
        return Promise.reject(
          new Error(
            `${keyName.trim()} ${intl.formatMessage({
              id: 'ApiKeys.modal.input.validation.keyAlreadyExists',
            })}`,
          ),
        );
      }

      return Promise.resolve();
    } catch {
      return Promise.reject(
        new Error(
          intl.formatMessage({
            id: 'ApiKeys.modal.input.validation.failedToValidateKeyName',
          }),
        ),
      );
    }
  };
};

export { createValidateKeyName, checkDuplicateKeyName };
